const languageMap: Record<string, string> = {
  Deutsch: 'de',
  English: 'en',
};

const defaultLanguage = 'en';

const languageCodes = Object.values(languageMap);
const languageNames = Object.keys(languageMap);

export const LocalesConfig = {
  languageMap,
  languageCodes,
  languageNames,
  defaultLanguage,
};
